import "./CustomerList.scss";
import { DownloadIcon, ImportIcon, PlusIcon, StarIcon, PeopleIcon, DescriptionIcon } from "../../../../../shared/margincalculator/components/icons/Icon";
import { useState } from "react";
import NewCustomers from "../NewCustomers/NewCustomers";

function Customers() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="customers">
      <header className="customers__header-top">
        <div className="customers__title-group">
          <h1>Kunden</h1>
          <p>0 von 0 Kunden</p>
        </div>
        <div className="customers__actions">
          <button className="customers__btn-action">
            <DownloadIcon /> CSV Export
          </button>
          <button className="customers__btn-action">
            <ImportIcon /> Import
          </button>
          <button
            className="customers__btn-action customers__btn-action--primary"
            onClick={() => setIsModalOpen(true)}
          >
            <PlusIcon /> Neuer Kunde
          </button>
        </div>
      </header>

      <div className="customers__controls">
        <div className="customers__search">
          <input
            type="text"
            placeholder="Suche nach Name, E-Mail, PLZ, Ort..."
          />
        </div>
        <button className="customers__filter-vip">
          <StarIcon /> Nur VIP
        </button>
      </div>

      <div className="customers__list-card">
        <div className="customers__list-card__header">
          <h3>
            <PeopleIcon /> Kundenliste
          </h3>
        </div>

        <div className="customers__list-card__empty-state">
          <DescriptionIcon />
          <p>
            Noch keine Kunden vorhanden
            <br />
            <span>Erstellen Sie Ihren ersten Kunden</span>
          </p>
        </div>
      </div>

      {isModalOpen && <NewCustomers onClose={() => setIsModalOpen(false)} />}
    </div>
  );
}

export default Customers;
